type RangeResult<T> = PromiseLike<{ data: T[] | null; error: { message: string } | null }>;

/** Paginate PostgREST results in 1000-row chunks. */
export async function fetchAllRows<T>(run: (from: number, to: number) => RangeResult<T>): Promise<T[]> {
  const page = 1000;
  let offset = 0;
  const out: T[] = [];
  for (;;) {
    const { data, error } = await run(offset, offset + page - 1);
    if (error) throw new Error(error.message);
    const chunk = data ?? [];
    if (chunk.length === 0) break;
    out.push(...chunk);
    if (chunk.length < page) break;
    offset += page;
  }
  return out;
}
